module.exports = __webpack_public_path__ + "static/media/mk2_back.0c09154b.png";